module.exports = __webpack_public_path__ + "static/Memoire-5d4c709313254c230866db5cf0e04d2e.pdf";